import React, { FunctionComponent } from 'react';
import { Box, Typography } from '@material-ui/core';
import customiseCheckboxPacksListStyles from './customiseCheckboxPacksListStyles';
import IFeature from '../../../../../../model/IFeature';
import CustomisePackItem from './CustomisePackItem';
import Translation from '../../../../../../../common/components/translation/Translation';
import useCustomizeCarContext from '../../../../../../hooks/useCustomizeCarContext';

export interface ICustomiseCheckboxPacksListProps {
  features: IFeature[];
  openAccessoryPackModal: (value: boolean, optionCode: string) => void;
  handleCheckboxChange: (code: string) => void;
}

const CustomiseCheckboxPacksList: FunctionComponent<ICustomiseCheckboxPacksListProps> = ({
  features,
  openAccessoryPackModal,
  handleCheckboxChange,
}) => {
  const styles = customiseCheckboxPacksListStyles();
  const { optimisticSelectedFeatures } = useCustomizeCarContext();

  return (
    <Box className={styles.container} data-test={`options:container`}>
      <Typography component="span" variant="caption" className={styles.subtitle}>
        <Translation id="trans__configurator__customise_page_options_section__section_subtitle" />
      </Typography>
      {features.map(feature => (
        <CustomisePackItem
          feature={feature}
          selected={optimisticSelectedFeatures?.includes(feature.code)}
          key={feature.code}
          onClick={handleCheckboxChange}
          openAccessoryPackModal={openAccessoryPackModal}
        />
      ))}
    </Box>
  );
};

export default CustomiseCheckboxPacksList;
